'use es6';

export const DESIGN_MANAGER_ACCESS = 'design-manager-access';
export const SOURCE_CODE_READ = 'source-code-read';
export const SOURCE_CODE_WRITE = 'source-code-write';
export const LANDING_PAGES_WRITE = 'landingpages-write';
export const LANDING_PAGES_ADVANCED_WRITE = 'landingpages-advanced-write';
export const LANDING_PAGES_NO_BRANDING = 'landing-pages-no-branding';
export const SITEPAGES_ACCESS = 'sitepages-access';
export const PAGES_WRITE = 'pages-write';
export const EMAIL_WRITE = 'email-write';
export const SHOW_RECOMMENDED_CONTENT = 'content-recommendations';
export const SMART_CONTENT = 'smartcontent';
export const EMAIL_FULL_EDITING = 'email-full-editing';
export const EMAIL_EDITOR_ACCESS = 'email-editor-access';
export const DOMAIN_PAGE_STYLESHEET_ACCESS = 'domain-page-attached-stylesheet-access';
export const TICKETS_ACCESS = 'workflows-tickets-access';
export const WORKFLOWS_DEALS_PLATFORM = 'workflows-platform-deals-access';
export const SKIP_ONBOARDING = 'skip-ide-onboarding';
export const LEGACY_DESIGN_MANAGER_ACCESS = 'legacy-design-manager-access';
export const HUBDB_SCHEMAS_READ = 'hubdb-schemas-read';
export const HUBDB_DATA_READ = 'hubdb-data-read';
export const MARKETING_CONTENT_RESTRICTED_WRITE = 'marketing-content-restricted-write';
export const SERVICE_CONTENT_RESTRICTED_WRITE = 'service-content-restricted-write';
export const SERVICE_FEEDBACK_ACCESS = 'service-feedback-access';
export const GLOBAL_CONTENT_WRITE_ACCESS = 'global-content-write-access';
export const SERVERLESS_FUNCTIONS = 'serverless-functions';
export const SALES_MEETINGS_ACCESS = 'sales-meetings-access';
export const CRM_ACCESS = 'crm-product';
export const JITA_USER = 'jita-user';
export const CMS_DND_TEMPLATES = 'cms-dnd-templates';
export const CTA_ACCESS = 'cta-access';
export const WEB_INTERACTIVES_ACCESS = 'calls-to-action-read';
export const MARKETING_VIDEO = 'marketing-video';
export const QUOTE_TEMPLATES = 'default-cms-quotes-theme-delivery';
export const PAYMENT_LINKS_READ = 'payment-links-read';
export const MARKETPLACE_ASSET_PROVIDER = 'marketplace-asset-provider';
export const BUSINESS_UNIT_ACCESS = 'business-units-access';
export const SYSTEM_PAGES_ACCESS = 'website-system-pages-write';
export const LANDING_PASSWORD_ACCESS = 'landingpages-password-protection';
export const SITE_PASSWORD_ACCESS = 'sitepages-password-protection';
export const SITE_SEARCH_ACCESS = 'site-search-read';
export const PERSONALIZATION_ACCESS = 'personalization-access';
export const COLLECTOR_DATA_QUERY_READ = 'collector-data-query-read';
export const COLLECTOR_DATA_QUERY_EXECUTE = 'collector-data-query-execute';
export const MESSAGING_ACCESS = 'messaging-access';